import { EnvironmentProviders, inject, provideEnvironmentInitializer } from '@angular/core';
import { RouteStore } from './route.store';

/**
 * Creates {@link RouteStore} with the root injector, before the initial navigation starts.
 * Register once, next to `RouterModule.forRoot`.
 */
export function provideEagerRouteStore(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    inject(RouteStore);
  });
}
